import React from 'react';
import { Award, CheckCircle, Shield, Clock } from 'lucide-react';
import { certifications } from '../mock';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';

const iconMap = {
  Award: Award,
  CheckCircle: CheckCircle,
  Shield: Shield,
  Clock: Clock
};

const CertificationsSection = () => {
  return (
    <section id="certifications" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Certifications & <span className="text-blue-600">Quality Standards</span>
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Committed to excellence through certified quality management and safety standards
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {certifications.map((cert) => {
            const Icon = iconMap[cert.icon];
            return (
              <Card
                key={cert.id}
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-600 text-center"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 mx-auto group-hover:bg-blue-600 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-lg mb-2 group-hover:text-blue-600 transition-colors">
                    {cert.title}
                  </CardTitle>
                  <CardDescription className="text-slate-600">
                    {cert.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Quality Commitment Banner */}
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src="https://images.unsplash.com/photo-1547895749-888a559fc2a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZW5naW5lZXJpbmd8ZW58MHx8fHwxNzY0ODU1Nzc2fDA&ixlib=rb-4.1.0&q=85"
            alt="Quality Standards"
            className="w-full h-80 object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 to-slate-900/80 flex items-center">
            <div className="container mx-auto px-4">
              <div className="max-w-2xl">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  Our Commitment to Quality
                </h3>
                <p className="text-lg text-blue-100 mb-6">
                  We maintain global quality standards in all our projects, ensuring timely delivery with zero tolerance on safety. Our ISO 9001:2008 certification is a testament to our dedication to excellence.
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="w-5 h-5 text-green-400" />
                    <span className="text-white font-medium">ISO Certified</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="w-5 h-5 text-green-400" />
                    <span className="text-white font-medium">Safety First</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="w-5 h-5 text-green-400" />
                    <span className="text-white font-medium">Timely Delivery</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="w-5 h-5 text-green-400" />
                    <span className="text-white font-medium">Global Standards</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
